// extracted by mini-css-extract-plugin
export default {"PostCreate":"qg_a bhl_qr bhl_a bhl_w bhl_ea"};